import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  menuvisible = false;

  constructor() { }

  ngOnInit() {
      if (window.innerWidth < 767)
        document.getElementById("menuitems").className = "hidden";;
  }

  showHide(){
    if(this.menuvisible){
      document.getElementById("menuitems").className = "hidden";
      this.menuvisible = false;
    } else {
      document.getElementById("menuitems").className = "secondary-nav clearfix right ml2";
      this.menuvisible = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts